import { useEffect, useState } from 'react';
import { Modal } from '@/components/shared/Modal';
import { Button } from '@/components/shared/Button';
import type { UnsavedSwitchDetail } from '@/contexts/SiteContext';

// UnsavedSwitchModal listens for the `aeo:unsaved-site-switch` window event
// that SiteContext.setSite dispatches when a switch is requested while a
// dirty buffer is registered. The modal asks the operator to discard or
// stay; on discard it invokes the proceed callback, which performs the
// pending navigation.
export function UnsavedSwitchModal() {
  const [state, setState] = useState<UnsavedSwitchDetail | null>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      const ce = e as CustomEvent<UnsavedSwitchDetail>;
      setState(ce.detail);
    };
    window.addEventListener('aeo:unsaved-site-switch', handler);
    return () => window.removeEventListener('aeo:unsaved-site-switch', handler);
  }, []);

  if (!state) return null;
  return (
    <Modal
      title="Unsaved changes"
      open={true}
      onClose={() => setState(null)}
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" size="sm" onClick={() => setState(null)}>
            Stay
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={() => {
              const proceed = state.proceed;
              setState(null);
              proceed();
            }}
          >
            Discard and switch
          </Button>
        </div>
      }
    >
      <p className="text-sm text-dash-secondary">
        You have unsaved changes to{' '}
        <strong className="text-dash-primary">{state.label || 'this draft'}</strong>
        . Switch sites anyway? Your changes will be discarded.
      </p>
    </Modal>
  );
}
